import React, {Component} from "react";
import {Translate} from "react-i18nify";
import {ReactSVG} from "react-svg";

import * as license from "../../constants/license";

import FramePanel from "../global/FramePanel";
import LicenseWizard from "./license/LicenseWizard";
import SimpleFooter from "../../containers/global/SimpleFooter";
import NotificationPanel from "../../containers/apps/default/NotificationPanel";

import imgRefresh from "../../resources/img/svgicons/refresh.svg";

export default class License extends Component {
    handleRefreshButtonClick = () => {
        this.props.refreshProducts();
    };

    getRefreshButton = () => {
        if (this.props.processStep === 2) {
            return (
                <button className="btn btn-info btn-md refresh-btn" onClick={this.handleRefreshButtonClick}>
                    <ReactSVG src={imgRefresh} className="svg-icon pull-left" alt="refresh" />
                    <Translate value="welcome.refresh" />
                </button>
            );
        }

        return "";
    };

    getSkipMessage = () => {
        if (this.props.licenseStatus !== license.STATUS_VALID_LEASED_LICENSE) {
            return "";
        }

        if (this.props.processStep === 3) {
            return (
                <div className="col-xs-12 text-under-line">
                    <Translate value="license.itemsMarkedasterisk" />
                </div>
            );
        }

        return (
            <div className="col-xs-12 color-primary text-center margin-bottom-10">
                <Translate value="license.skipNewLicense" />
            </div>
        );
    };

    getWindowStyle = () => {
        if (this.props.virtualKeyboard.keyboardState) {
            return "license-window keyboard-open";
        }

        return "license-window";
    };

    render() {
        return (
            <div className="container-fluid content license bg-redlike" style={{WebkitAppRegion: "drag"}}>
                <FramePanel />
                <div className={"flex flex-column " + this.getWindowStyle()} style={{WebkitAppRegion: "no-drag"}}>
                    <div className="col-xs-12 redlike-logo logo-btn-row">
                        <div className="redlike-logo-all" />
                        <div>{this.getRefreshButton()}</div>
                    </div>
                    <LicenseWizard />
                    {this.getSkipMessage()}
                </div>
                <NotificationPanel />
                <SimpleFooter virtualKeyboardSupport={true} />
            </div>
        );
    }
}
